export default "__VITE_ASSET__DC0eYaCG__"